import React from "react";
import { Icons } from "../../constants/icon-library";
import { getIcon } from "../../constants/constants";

const AgentDetails = ({
  formik,
  assistantOptions,
  handleDelete,
  isDefaultAgent,
}) => {
  return (
    <div className="row mt-4">
      <div className="card border p-0">
        <div className="card-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <h5>
                Assistants <span className="text-danger">*</span>
              </h5>

              <div
                className="border rounded p-3"
                style={{ maxHeight: "320px", overflowY: "auto" }}
              >
                {assistantOptions.length === 0 ? (
                  <p className="text-muted mb-0">No assistants installed.</p>
                ) : (
                  assistantOptions.map((assistant) => {
                    let iconSrc =
                      getIcon(assistant?.name) ||
                      assistant?.platform;

                    return (
                      <div
                        key={assistant.value}
                        className="d-flex align-items-center mb-2"
                      >
                        <input
                          id={`assistant-${assistant.value}`}
                          type="checkbox"
                          className="form-check-input mb-0 me-2"
                          style={{ cursor: "pointer" }}
                          checked={formik.values.assistants.includes(
                            assistant.value,
                          )}
                          onChange={(e) => {
                            if (e.target.checked) {
                              formik.setFieldValue("assistants", [
                                ...formik.values.assistants,
                                assistant.value,
                              ]);
                            } else {
                              formik.setFieldValue(
                                "assistants",
                                formik.values.assistants.filter(
                                  (id) => id !== assistant.value,
                                ),
                              );
                            }
                          }}
                        />

                        <label
                          htmlFor={`assistant-${assistant.value}`}
                          className="mb-0 d-flex align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={iconSrc}
                            alt={assistant.label}
                            className="me-2"
                            style={{
                              width: "20px",
                              height: "20px",
                              objectFit: "contain",
                            }}
                          />

                          {assistant.label}
                        </label>
                      </div>
                    );
                  })
                )}
              </div>

              {formik.touched.assistants && formik.errors.assistants && (
                <div className="invalid-feedback d-block">
                  {formik.errors.assistants}
                </div>
              )}
            </div>

            <div
              className={`d-flex ${
                isDefaultAgent
                  ? "justify-content-end"
                  : "justify-content-between"
              }`}
            >
              {!isDefaultAgent && (
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={handleDelete}
                >
                  <i className={`wb ${Icons("delete")} me-2`} />
                  Delete
                </button>
              )}

              <button
                type="submit"
                className="btn btn-primary"
                disabled={formik.isSubmitting}
              >
                <i className={`wb ${Icons("save")} me-2`} />
                Update Agent
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgentDetails;
